const { get } = require("./_utils");
const { setLocalItem, getLocalItem } = require("../utils/store/browserStorage")

module.exports = async function () {
  try {
    let data = await get("/info");
    // let { simtopy } = global.store.getState()
    let {
      platforms,
      groups,
      theme,
      apps,
      contactPageEnabled,
      presentationButtonEnabled,
      guestsEnabled,
      colorButtonOnProjectBar
    } = data;

    if (data.themes) theme = data.themes[0]
    if (theme) setLocalItem("selectedTheme", theme.uid)
    if (global.document && platforms && platforms.length && platforms[0] && platforms[0].name) {
      let platformName = getLocalItem("platformName")
      if (platformName !== platforms[0].name) {
        platformName = platforms[0].name
        setLocalItem("platformName", platformName)
      }
      //global.document.title = platformName
    }
    global.store.dispatch({
      type: 'SET_INFO',
      platforms,
      groups,
      apps,
      themeUid: theme ? theme.uid : null,
      theme: theme ? {
        ...theme,
        palette: {
          ...theme.palette,
          type: theme.type
        }
      } : {},
      backgroundFile: theme ? theme.backgroundFile : null,
      logoFile: theme ? theme.logoFile : null,
      faviconFile: theme ? theme.faviconFile : null,
      contactPageEnabled,
      presentationButtonEnabled,
      guestsEnabled,
      colorButtonOnProjectBar
    });

    return data;
  } catch (err) {
    return Promise.reject(err);
  }
}
